module.exports = __webpack_public_path__ + "img/weddings_03_V.69e2462e.webp";